<template>
  <Layout :footer-style="2" header-class="header-left-align" nav-alignment="right" :header-transparency="false" :show-top-header="true" buy-button-class="btn-default btn-small">
    <div class="rwt-timeline-area rn-section-gap">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <SectionTitle
                subtitle="YAO XIE GONG MAO"
                text-align="center"
                title="生产服务"
                data-aos="fade-up"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <ProductServicesTimeline />
          </div>
        </div>
      </div>
    </div>





  </Layout>
</template>

<script>

import ProductServicesTimeline from "./ProductServiceTimeline";
import SectionTitle from "../../components/elements/sectionTitle/SectionTitle";
import Layout from "../../components/common/Layout";
export default {
  name: "ProductServices",
  components: {ProductServicesTimeline,SectionTitle,Layout},
  data(){
    return{
      timelineData: [
        {
          id: '1',
          date: '',
          title: '生产流程',
          description: '描述.',
          image: 'timeline-04',
          thumb: require(`@/assets/images/timeline/timeline-03.jpg`),
          src: require(`@/assets/images/timeline/timeline-03.jpg`),
          type: 'image',
          workingStep: [
            /*{
              stepTitle: 'Follow this process',
              stepDescription: 'Lorem ipsum dolor sit amet at consectetur adipisicing',
            },
            {
              stepTitle: 'Working experience',
              stepDescription: 'Lorem ipsum dolor sit amet at consectetur adipisicing',
            },*/
          ]
        },
        {
          id: '2',
          date: '步骤1',
          title: '材料准备',
          description: '描述.',
          image: 'timeline-04',
          thumb: require(`@/assets/images/timeline/timeline-04.jpg`),
          src: require(`@/assets/images/timeline/timeline-04.jpg`),
          type: 'image',
          workingStep: [
            /*{
              stepTitle: 'Follow this process',
              stepDescription: 'Lorem ipsum dolor sit amet at consectetur adipisicing',
            },
            {
              stepTitle: 'Working experience',
              stepDescription: 'Lorem ipsum dolor sit amet at consectetur adipisicing',
            },*/
          ]
        },
      ],
    }
  }
}
</script>
